import React, { useState } from "react";
import styles from "./timelineview.module.scss";
// import meetnow from "../../../../styles/images/meetnow.svg";
// import joinnow from "../../../../styles/images/joinnow.svg";
// import eventsvg from "../../../../styles/images/eventsvg.svg";
import { Timeline } from "antd";
import { URButton } from "../../../../shared/widgets/button";
import { RRuleTimeCal } from "../../../../base/meetingService/utils/meetingServices";
import store from "../../../../context/store/store";
import _ from "lodash";
import moment from "moment";
import { LoginState, UserDetails } from "../../../../models/model";
import {
  convertDuration, findHostName, findHostNameYou
} from "../../../../base/callService/common";
import { storeMeetingPage, storeWindowState } from "../../../../base/meetingService/meetingStoreServices";
import CopyInvitePopUp from "../popUp/copyInvitePopUp";
import { useSelector } from "react-redux";
import { getVideoRecordingLists, updateMeetingRead } from "../../../../base/meetingService/apiService";
import { useHistory } from "react-router-dom";
import { Types } from "../../../../context/action/action";
type calendarTimeLineState = {
  isCopyModal: boolean;
  selectedMeetingDetail: any;
}
export default function TimelineView() {
  let { meetingReducer }: any = useSelector((state: any) => state);
  let { meetingListByDate, filterDate } = meetingReducer;
  const [calendarTimeLineState, setCalendarTimeLineState] = useState<calendarTimeLineState>({
    isCopyModal: false,
    selectedMeetingDetail: {}
  });
  let previousMeetingArray: any = ['Completed', 'Missed', 'Cancelled'];
  let { userdetails }: LoginState = store.getState().loginReducer; 
  const history = useHistory();
  const redirectToMeeting = (elem: any) => {

    let replaced_url: any= elem.invite_url?.includes("stagemeet") ? `${elem.invite_url}${elem?.meetings_type === 1 ? "?type=meetnow" : ""}`: `${elem.invite_url?.replace('meet.unifiedring', 'meet.worktual')} ${elem?.meetings_type === 1 ? "?type=meetnow" : ""}`;
     window.open(replaced_url, '_blank'); 
  }

  const RescheduleMeeting = (elem: any) => {
    storeMeetingPage(elem);
    storeWindowState("reschedule");
  };
  const copyMeetingFun = (data: any) => {
    setCalendarTimeLineState({ ...calendarTimeLineState, isCopyModal: true, selectedMeetingDetail: data });
  };
  const copyInvitation = () => {
    setCalendarTimeLineState({ ...calendarTimeLineState, isCopyModal: false, selectedMeetingDetail: [] });
  }

  const openDetailPage = (elem: any) => {
    history.push("/meeting");
    store.dispatch({
      type: Types.VIDEOMEET_COUNT_STATUS,
      payload: {
        meetingCountStatus:true
      }
    })
      updateMeetingRead(elem?.uuid);
      storeMeetingPage(elem);
      storeWindowState("meetingDetails");
      let recdata: any ={};
      recdata.offset = 0;
      recdata.limit = 10;
      recdata.search = elem?.uuid;
      getVideoRecordingLists(recdata);
  }

  let disPlayDate = 'today';

  if(filterDate){
    let currentDate =  moment(new Date()).format("YYYY-MM-DD");

    if(currentDate === filterDate) disPlayDate = 'today'
    else disPlayDate = filterDate 
  }
  return (
    <>
      <p className={styles.meetingsCount}>{meetingListByDate?.length === 0 ? "No" : meetingListByDate?.length}  Meetings {meetingListByDate?.length === 0 ? "for" : ""} {disPlayDate !== "today" ? moment(disPlayDate).format("DD-MM-YYYY") : "today"}</p>
      <div className={`scroller ${styles.timelineView}`}>
        <Timeline mode='left' className="custTimeline">
          {!_.isEmpty(meetingListByDate) && meetingListByDate.map((elem: any,index:any) => {
            const currentTimeStamp=Date.now();  /// Current Timestamp
            const subTimpstampval= elem.start_timestamp-currentTimeStamp;
            const diffTimeStamp=Math.floor(subTimpstampval/60000);
            // if(timestampStartDate!==currentDate){
            //   var diffval =  100;
            //   //console.log('not equal');
            // }else {
              var diffval = diffTimeStamp<=0 ? 100 : diffTimeStamp;
              const dotColor = elem.status === "Cancelled" ? "cancelledDot" : elem.status === "Missed" ? "missedDot" : elem.status === "Completed" ? "completedDot" : elem.status === "Ongoing" ? "onGoingDot" : "blue" 
              //console.log('equal');
            //}
            const colorDiff = diffval <= 5 ? "blue in5mins" : diffval <= 15 ? "blue" : (elem.status === "Start" || elem.status ==="Join") ?  'blue completed':"blue";
            // console.log('Inner TimeDuration -- --', elem.title +'---'+diffDuration.minutes());
            // console.log('Inner diffDuration -- --', elem.status);
            let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
            return (
              <Timeline.Item color={dotColor} label={(moment(elem.start_timestamp).format('hh:mm A')) + ' - ' +
                (moment(elem.rrule !== "" ? RRuleTimeCal(elem.start_timestamp, elem.duration_minutes) : elem.end_timestamp).format('hh:mm A'))
              } key={index}>
                <div className={elem.status === "Cancelled" ? `${styles.timelineMeet} ${styles.ifcanceled}` : elem.status === "Missed"
                  ? `${styles.timelineMeet} ${styles.ifmissed}` : elem.status === "Completed" ? `${styles.timelineMeet} ${styles.ifcompleted}`: styles.timelineMeet}>
                  <div className={styles.timelineDetail} onClick={()=>openDetailPage(elem)}>
                    <p className={!previousMeetingArray.includes(elem.status) ?` ${styles.meetTitle} ${styles.widthoverdot}` : styles.meetTitle}>
                      {elem.title}
                    </p>
                    <div className={`${styles.meetingsBtm} ${styles.widthoverdot}`}>
                      <div className={styles.userName}><span className="icon_timer"></span>{convertDuration(elem.duration_minutes)}</div>
                      <div className={styles.recType}>
                        <span className="icon_User-outline"></span>
                        {!_.isUndefined(findHostNameYou(elem)) && `${findHostNameYou(elem)}(Host)`}
                      </div>
                    </div>
                    
                  </div>
                  {/* <div className={styles.startsTimeMissed}>Missed</div> */}
                  {/* <div className={styles.startsTime}>Starts in 5 min</div> */}
                  {(elem.status === "Ongoing Meeting" || elem.status === "Missed" || elem.status === "Completed" || elem.status === "Cancelled") &&
                    <div className={elem.status === "Ongoing Meeting" ? `${styles.startsTime5min} ${styles.ongoing}`
                      : elem.status === "Missed" ? `${styles.startsTime} ${styles.startsTimeMissed}` : elem.status === "Completed"
                        ? `${styles.startsTime5min} ${styles.completed}` : elem.status === "Cancelled"
                        ? `${styles.startsTime5min} ${styles.cancelled}` : `${styles.startsTime}`}>{elem.status}</div>}
                  <div className={styles.timelineBtns}>
                  {(diffval <= 5 && (elem.status !== "Completed" && elem.status !== "Cancelled" ) &&(elem.status !== "Ongoing Meeting"  || elem.status ==="Missed")) ? <label className={`${styles.startsTime5min} ${styles.in5mins}`}>In 5 minutes</label> :
                   (diffval <= 15 && (elem.status !== "Completed" && elem.status !== "Cancelled" ) &&(elem.status !=="Ongoing Meeting"  || elem.status ==="Missed")) ? <label className={`${styles.startsTime5min} ${styles.in15mins}`}>In 15 minutes</label> : ''}
                     {!previousMeetingArray.includes(elem.status) && <URButton className='urButton buttonWhite buttonSm mr8' name='Copy Invitation'  onClick={() => copyMeetingFun(elem)}/>}
                    {(elem.status === "Join" || elem.status==="Start") ? <URButton className='urButton buttonBlue buttonSm' name={elem.sip_id === userdetails.sip_login_id ? "Start" : "Join"} onClick={() => redirectToMeeting(elem)}></URButton> :
                   ((elem.status === "Cancelled" || elem.status === "Missed") && elem.sip_id === userdetails.sip_login_id) ? <URButton className='urButton buttonBlue buttonSm' name="Reschedule" onClick={()=>RescheduleMeeting(elem)}></URButton> : elem.status === "Ongoing Meeting" ? <URButton className='urButton buttonBlue buttonSm' name={"Join"} onClick={() => redirectToMeeting(elem)}></URButton> :
                    elem.status ==="Rejoin" ? <URButton className='urButton buttonBlue buttonSm' name={"Re-join"} onClick={() => redirectToMeeting(elem)}></URButton> : null }
                  </div>
                </div>
              </Timeline.Item>
            )
          })}
        </Timeline>
      </div>
      {/* <>
      <p className={styles.meetingsCount}>5 Meetings on Today</p>
      <div className={`scroller ${styles.timelineView}`}>
        <Timeline mode='left' className="custTimeline">
          <Timeline.Item label="12:00 - 12:15 pm">
            <div className={`${styles.timelineMeet} ${styles.ifcanceled}`}>
              <div className={styles.timelineDetail}>
                <p className={styles.meetTitle}>
                  Design team stand-up
                </p>
                <div className={styles.meetingsBtm}>
                  <div className={styles.userName}><span className="icon_timer"></span>15m</div>
                  <div className={styles.recType}>
                    <span className="icon_Profile-outline"></span>Marilyn Adam (You)</div>
                </div>
              </div>
              <div className={styles.timelineBtns}>
                <URButton className='urButton buttonBlue buttonSm' name="Reschedule"></URButton>
              </div>
            </div>
          </Timeline.Item>
          <Timeline.Item label="2:00 - 2:30 pm">
            <div className={`${styles.timelineMeet} ${styles.ifmissed}`}>
              <div className={styles.timelineDetail}>
                <p className={styles.meetTitle}>
                  Monthly team meet-up
                </p>
                <div className={styles.meetingsBtm}>
                  <div className={styles.userName}><span className="icon_timer"></span>15m</div>
                  <div className={styles.recType}>
                    <span className="icon_Profile-outline"></span>Marilyn Adam (You)</div>
                </div>
              </div>
              <div className={styles.startsTimeMissed}>Missed</div>
            </div>
          </Timeline.Item>
          <Timeline.Item label="6:00 - 8:30 pm">
            <div className={styles.timelineMeet}>
              <div className={styles.timelineDetail}>
                <p className={styles.meetTitle}>
                Weekly team meet-up
                </p>
                <div className={styles.meetingsBtm}>
                  <div className={styles.userName}><span className="icon_timer"></span>15m</div>
                  <div className={styles.recType}>
                    <span className="icon_Profile-outline"></span>Marilyn Adam (You)</div>
                </div>
              </div>
              <div className={styles.startsTime}>Starts in 5 min</div>
              <div className={styles.timelineBtns}>
                <URButton className='urButton buttonWhite buttonSm right8' name='Copy Invitation'/>
                <URButton className='urButton buttonBlue buttonSm' name="Start"></URButton>
              </div>
            </div>
          </Timeline.Item>
          <Timeline.Item label="8:00 - 10:30 pm">
            <div className={styles.timelineMeet}>
              <div className={styles.timelineDetail}>
                <p className={styles.meetTitle}>
                Monthly team meet-up
                </p>
                <div className={styles.meetingsBtm}>
                  <div className={styles.userName}><span className="icon_timer"></span>15m</div>
                  <div className={styles.recType}>
                    <span className="icon_Profile-outline"></span>Marilyn Adam (You)</div>
                </div>
              </div>
              <div className={styles.startsTime}>Starts in 5 min</div>
              <div className={styles.timelineBtns}>
                <URButton className='urButton buttonWhite buttonSm' name='Copy Invitation'/>
                <URButton className='urButton buttonBlue buttonSm' name="Start"></URButton>
              </div>
            </div>
          </Timeline.Item>
        </Timeline>
      </div>
    </> */}
      {calendarTimeLineState.isCopyModal && <CopyInvitePopUp detailPage={calendarTimeLineState.selectedMeetingDetail} invitePropsCalling={copyInvitation}
        isCopyModal={calendarTimeLineState.isCopyModal} />}
    </>
  );
};